import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { DVFormArray, DVFormGroup, DVFormControl } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import * as _ from 'lodash';
@Component({
  selector: 'app-add-package-day',
  templateUrl: './add-package-day.component.html',
  styleUrls: ['./add-package-day.component.css']
})
export class AddPackageDayComponent implements OnInit {
  @Input() packageForm: DVFormGroup;
  private pkgDays: DVFormArray;

  ngOnInit() {
    this.pkgDays = this.packageForm.controls
      .PackageDays as DVFormArray;
    this.packageForm.controls.duration.valueChanges.subscribe(duration => {
      if (duration > this.pkgDays.length) {
        this.addDays(duration);
      } else if (duration < this.pkgDays.length) {
        this.removeDays(duration);
      }
    });
  }

  private addDays(duration) {
    const currentLength = this.pkgDays.length;
    const difference = duration - currentLength;
    for (let i = 0; i < difference; i++) {
      this.pkgDays.addChildrenToArray(
        this.generatePackageDay()
      );
    }
  }

  private removeDays(duration) {
    const currentLength = this.pkgDays.length;
    for (let i = currentLength; i > duration; i--) {
      this.pkgDays.removeAt(i - 1);
    }
  }

  get packageDaysAsFormArray() {
    return this.packageForm.controls.PackageDays as DVFormArray;
  }

  getActivityFromPkgDayForm(expDay: DVFormGroup) {
    return expDay.controls.Activities as DVFormArray;
  }

  private generatePackageDay() {
    return new DVFormGroup({
      id: new DVFormControl(),
      order: new DVFormControl(),
      title: new DVFormControl(null, {
        'Day Title is required': Validators.required
      }),
      meals: new DVFormControl([]),
      overnight: new DVFormControl(null),
      description: new DVFormControl(null),
      Activities: new DVFormArray(
        [],
        [
          {
            name: 'id',
            type: 'CONTROL',
            default: null
          },
          {
            name: 'title',
            type: 'CONTROL',
            default: null,
          },
          {
            name: 'order',
            type: 'CONTROL',
            default: null
          },
          {
            name: 'description',
            type: 'CONTROL',
            default: null,
          },
          {
            name: 'Pictures',
            type: 'CONTROL',
            default: [],
          },
        ],
        1,
        {
          
        }
      )
    });
  }
}
